<script>
import OrderButton from "./_Button";

export default {
  components: {
    OrderButton
  }
};
</script>

<template>
  <section>
    <a
      href="https://donamaid.freshdesk.com/support/tickets/new"
      target="_blank"
      rel="noopener noreferrer"
    >
      <order-button title="solicitar nota fiscal" image="icon_nf.svg"/>
    </a>
  </section>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/RequestInvoice.vue